var _componentColorPicker = function($context) {
    if (!$().spectrum) {
        console.warn('Warning - spectrum.js is not loaded.');
        return;
    }
    
    ($context instanceof jQuery ? $context.find('.js-colorpicker-show-input') : $('.js-colorpicker-show-input')).each(function() {
        var $me = $(this);
       
        $me.spectrum({
            preferredFormat: "hex",
            showInput: true,
            chooseText: $me.data('choose-text') ? $me.data('choose-text') : 'Wählen',
            cancelText: $me.data('cancel-text') ? $me.data('cancel-text') : 'Abbrechen'
        });
    });        
}; 

function init($context) {
    _componentColorPicker($context);
}

export const ColorPicker = {
    init
}